export default __webpack_public_path__ + "static/media/logo_ital.d93b8365.svg";